// extracted by mini-css-extract-plugin
export default {"photo":"WSVirtualAssistant_photo__XdVng","card":"WSVirtualAssistant_card__+vC3V","msg":"WSVirtualAssistant_msg__M+RLK"};